<template>
    <div>
        <div style="text-align: center;">
            <h5>ยืนยันการบันทึกจบ</h5>
            <br/>
            <button type="button"
                    @click="submitData"
                    class="btn btn-success">ตกลง
            </button>
            &nbsp&nbsp
            <button type="button"
                    @click="cancelData"
                    class="btn btn-outline-secondary">ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props:{msg : ''},
        name: "ConfirmEmpModal",
        methods:{
            submitData(){
                this.$emit('submit',true);
            },
            cancelData(){
                this.$emit('submit',false);
            }
        }
    }
</script>

<style scoped>

</style>
